/** Service Worker nur im Produktions-Build (im Dev-Server würde er HMR stören). */
export function registerServiceWorker() {
  if (!import.meta.env.PROD || !("serviceWorker" in navigator)) return;
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch(() => {
      /* ohne SW funktioniert die App weiter, nur ohne Offline-Seite */
    });
  });
}
